import { render, staticRenderFns } from "./WorkerDash.vue?vue&type=template&id=1cb9e1d9&scoped=true&"
import script from "./WorkerDash.vue?vue&type=script&lang=js&"
export * from "./WorkerDash.vue?vue&type=script&lang=js&"
import style0 from "./WorkerDash.vue?vue&type=style&index=0&id=1cb9e1d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb9e1d9",
  null
  
)

export default component.exports